var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "history-record-wrapper"
  }, [_c("div", {
    staticClass: "flex-center history-list-btn",
    style: {
      height: _vm.topBarHeight + "px"
    },
    on: {
      click: _vm.viewHistory
    }
  }, [_c("svg-icon", {
    staticClass: "m-r-4",
    attrs: {
      name: "history",
      size: "20"
    }
  })], 1), _c("van-popup", {
    style: {
      height: "100%",
      width: "100%",
      background: "#eef6ff",
      "z-index": 4000
    },
    attrs: {
      position: "left"
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "history-header"
  }, [_c("div", {
    staticClass: "header-title"
  }, [_vm._v("历史记录")]), _c("div", {
    staticClass: "close-btn",
    on: {
      click: function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.handleClose.apply(null, arguments);
      }
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "van-icon-clear",
      size: "20"
    }
  })], 1)]), _c("div", {
    ref: "scrollContainer",
    staticClass: "scroll-container",
    on: {
      scroll: _vm.handleScroll
    }
  }, _vm._l(_vm.historyList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "scroll-item",
      on: {
        click: function click($event) {
          return _vm.handleClick(item);
        }
      }
    }, [_c("svg-icon", {
      staticStyle: {
        "min-width": "14px",
        "margin-top": "4px",
        "margin-right": "4px"
      },
      attrs: {
        name: "history-item"
      }
    }), _c("div", [_c("div", {
      staticClass: "over-flow-ellipsis"
    }, [_vm._v(_vm._s(item.question) + " ")]), _c("div", {
      staticClass: "m-t-8 time"
    }, [_vm._v(_vm._s(item.createTime))])])], 1);
  }), 0)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };